import { Link } from "react-router-dom";
import { RegistrationForm } from "../components/RegistrationForm";

export function Landing() {
  return (
    <main>
      {/* Hero Section — warm cream backdrop */}
      <section className="relative bg-[#f9f2e2] overflow-hidden">
        <div className="relative max-w-4xl mx-auto px-4 pt-12 pb-16 md:pb-24 text-center">
          {/* Logo — bigger & centered */}
          <img
            src="/kv-logo.svg"
            alt="Kickstart Vengara"
            className="w-[300px] mx-auto mb-12"
          />

          {/* Sammanam title SVG — beautiful reference typography */}
          <img
            src="/sammanam-text.svg"
            alt="Sammanam - Kickstart Vengara"
            className="w-full max-w-3xl mx-auto mb-6"
          />

          {/* CTA Button — navigate to winners page */}
          <div className="mb-6">
            <Link
              to="/leaderboard"
              className="inline-flex items-center gap-2 bg-[#5716a8] text-white text-xl px-11 py-3 rounded-lg font-semibold border-[3px] border-[#985ae6] hover:scale-105 hover:shadow-lg transition-all duration-200 capitalize mt-10"
            >
              Check Winners 🏆
            </Link>
          </div>

          {/* Team photo section */}
          <div className="mt-16 md:mt-20">
            <img
              src="/team-photo.jpg"
              alt="Kickstart Vengara Team"
              className="w-full max-w-5xl mx-auto"
            />
          </div>

        </div>
      </section>

      {/* Registration Section — purple heading to match palette */}
      <section id="registration" className="max-w-xl mx-auto px-4 py-12 -mt-8 relative z-10">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-[#5716a8] font-google-sans">Registration</h2>
          <p className="text-[#985ae6]/70 mt-1 font-roboto-mono">
            Registration is now closed. Check out the winners below!
          </p>
        </div>
        <RegistrationForm />
      </section>

      {/* Footer */}
      <footer className="text-center py-5 border-t border-[#985ae6]/20 mt-16">
        <div className="max-w-4xl mx-auto px-4">
          <p className="text-sm text-[#5716a8]/60 font-roboto-mono">
            &copy; 2026 MLA Vengara. All Rights Reserved.
          </p>
        </div>
      </footer>
    </main>
  );
}
